import EventNoteIcon from "@mui/icons-material/EventNote";
import { FREE_SELECTION_SLOTS, GraduationServicePath, SCHEDULES } from "utils/constants";
import permissions from "app/permissions";
import ListScheduleFreeSelectionSlot from "./List";
import CreateScheduleFreeSelectionSlot from "./Create";
import ShowScheduleFreeSelectionSlot from "./Show";
import EditScheduleFreeSelectionSlot from "./Edit";

export const resources = {
  isMenu: true,
  icon: <EventNoteIcon />,
  name: GraduationServicePath + SCHEDULES + "/" + FREE_SELECTION_SLOTS,
  title: "Разписание - Свободен избор",
  list: <ListScheduleFreeSelectionSlot />,
  create: <CreateScheduleFreeSelectionSlot />,
  edit: <EditScheduleFreeSelectionSlot />,
  show: <ShowScheduleFreeSelectionSlot />,
  permission: permissions.canPreviewInternshipSchedules,
};
